import {combineReducers} from 'redux';

import {LOGIN_OUT, LOGIN_IN, LOGIN_CANCEL, USER_UPDATE} from './action-types'
import cookie from '../utils/cookie';

const Login = (state="", action)=>{
    switch(action.type){
        case LOGIN_OUT:
            cookie.removeCookie("user");
            return action.user
        case LOGIN_IN:
            cookie.setCookie("user", action.user)
            return action.user
        case LOGIN_CANCEL:
            return ""
        default:
            return state
    }
}
const User = (state={}, action)=>{
    switch(action.type){
        case USER_UPDATE:
            return action.user
        default:
            return state
    }
}

export default combineReducers({
    Login, User
})